// extracted by mini-css-extract-plugin
export default {"collapse":"ApplicantDetails_collapse__Sa71L"};